import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { areAddedAlbums, areRemovedAlbums } from "../../reducers/albumListState"
import { useSnackbar } from "notistack";
import SnackbarRefreshSavedAlbumsButton from "../../components/snackbar/SnackbarRefreshSavedAlbumsButton";

export const useSavedAlbumsChanges = () => {
    const addedAlbums = useSelector(areAddedAlbums);
    const removedAlbums = useSelector(areRemovedAlbums);

    const [addedAlbumsSnackbarVisible, setAddedAlbumsSnackbarVisible] = useState(false);
    const [removedAlbumsSnackbarVisible, setRemovedAlbumsSnackbarVisible] = useState(false);

    const ADDED_ALBUMS_SNACKBAR_KEY = 'addedAlbumsSnackbar';
    const REMOVED_ALBUMS_SNACKBAR_KEY = 'removeAlbumsSnackbar';

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        if(addedAlbums && !addedAlbumsSnackbarVisible)
        {
            enqueueSnackbar('New saved albums have been added', 
                { 
                    key: ADDED_ALBUMS_SNACKBAR_KEY, 
                    variant: 'warning', 
                    persist: true,
                    action: snackbarKey => <SnackbarRefreshSavedAlbumsButton snackbarKey={snackbarKey} />,
                    onClose: () => setAddedAlbumsSnackbarVisible(false)
                });

            setAddedAlbumsSnackbarVisible(true);
        }

        if(removedAlbums && !removedAlbumsSnackbarVisible)
        {
            enqueueSnackbar('Some saved albums have been deleted', 
                { 
                    key: REMOVED_ALBUMS_SNACKBAR_KEY,
                    variant: 'warning', 
                    persist: true,
                    action: snackbarKey => <SnackbarRefreshSavedAlbumsButton snackbarKey={snackbarKey} />,
                    onClose: () => setRemovedAlbumsSnackbarVisible(false)
                });

            setRemovedAlbumsSnackbarVisible(true);
        }

        if(!addedAlbums && addedAlbumsSnackbarVisible)
        {
            closeSnackbar(ADDED_ALBUMS_SNACKBAR_KEY);
        }

        if(!removedAlbums && removedAlbumsSnackbarVisible)
        {
            closeSnackbar(REMOVED_ALBUMS_SNACKBAR_KEY);
        }

    // eslint-disable-next-line
    }, [addedAlbums, removedAlbums, enqueueSnackbar, closeSnackbar]);

    return { addedAlbums, removedAlbums };
}